<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { RouterLink } from 'vue-router'
import ArrowIcon from '@/components/shared/ArrowIcon.vue'

const { t } = useI18n()
</script>

<template>
  <section class="bg-slate-50 py-24">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="max-w-2xl">
        <p class="text-sky-600 font-semibold text-sm uppercase tracking-widest">
          {{ t('home.participants.section_label') }}
        </p>
        <h2 class="text-3xl md:text-4xl font-bold text-slate-900 mt-3">
          {{ t('home.participants.heading') }}
        </h2>
        <p class="text-slate-500 mt-4">
          {{ t('home.participants.subtext') }}
        </p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
        <div class="bg-white rounded-2xl p-8 border border-slate-100 hover:border-sky-200 hover:shadow-lg transition-all">
          <div class="w-10 h-10 text-sky-600 mb-6">
            <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-full h-full">
              <circle cx="18" cy="18" r="10" stroke="currentColor" stroke-width="2.5" />
              <path d="M26 26l8 8" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" />
              <path d="M14 18h8M18 14v8" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
          </div>
          <h3 class="text-lg font-bold text-slate-900">{{ t('home.participants.card_discover_title') }}</h3>
          <p class="text-slate-500 mt-3 leading-relaxed">{{ t('home.participants.card_discover_body') }}</p>
        </div>

        <div class="bg-white rounded-2xl p-8 border border-slate-100 hover:border-sky-200 hover:shadow-lg transition-all">
          <div class="w-10 h-10 text-sky-600 mb-6">
            <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-full h-full">
              <path d="M22 5L10 22h12l-4 13 18-17H24L22 5z" stroke="currentColor" stroke-width="2.5" stroke-linejoin="round" fill="currentColor" fill-opacity="0.1" />
            </svg>
          </div>
          <h3 class="text-lg font-bold text-slate-900">{{ t('home.participants.card_register_title') }}</h3>
          <p class="text-slate-500 mt-3 leading-relaxed">{{ t('home.participants.card_register_body') }}</p>
        </div>

        <div class="bg-white rounded-2xl p-8 border border-slate-100 hover:border-sky-200 hover:shadow-lg transition-all">
          <div class="w-10 h-10 text-sky-600 mb-6">
            <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-full h-full">
              <rect x="6" y="6" width="28" height="28" rx="3" stroke="currentColor" stroke-width="2.5" />
              <path d="M13 15h14M13 20h10M13 25h12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" />
              <circle cx="30" cy="10" r="5" fill="currentColor" fill-opacity="0.15" stroke="currentColor" stroke-width="2" />
              <path d="M28.5 10l1 1 2-2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <h3 class="text-lg font-bold text-slate-900">{{ t('home.participants.card_manage_title') }}</h3>
          <p class="text-slate-500 mt-3 leading-relaxed">{{ t('home.participants.card_manage_body') }}</p>
        </div>
      </div>

      <div class="mt-14 text-center">
        <RouterLink
          :to="{ name: 'public.for-participants' }"
          class="inline-flex items-center gap-2 bg-sky-600 hover:bg-sky-500 text-white font-semibold rounded-lg px-6 py-3 transition-colors"
        >
          {{ t('home.participants.cta') }}
          <ArrowIcon direction="right" class="w-4 h-4" />
        </RouterLink>
      </div>
    </div>
  </section>
</template>
